import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ImageWithBasePath from "../imageWithBasePath";
import { all_routes } from "../../../feature-module/router/all_routes";
import { useDispatch, useSelector } from "react-redux";
import {
  setExpandMenu,
  setMiniSidebar,
  setMobileSidebar,
} from "../../data/redux/commonSlice";
import { useAppSelector } from "../../data/redux/hooks";
import { setPhone } from "../../data/redux/slices/appCommonSlice";
import { resetProfile } from "../../data/redux/slices/ProfileSlice";
import api from "../../axios/axiosInstance";
import FloatingDialer from "../floating-dialer/FloatingDialer";
import {
  closeDialer,
  openDialer,
} from "../../data/redux/slices/FloatingDialerSlice";
import { fetchCredits, setBalance } from "../../data/redux/slices/CreditsSlice";
import { clearContactsCache } from "../../data/redux/slices/ContactSlice";
import { clearContactsCache as clearLeadsCache } from "../../data/redux/slices/LeadSlice";
import { useDebounce } from "../../hooks/useDebounce";
import FloatingChatbot from "../../../feature-module/crm/floatingChatbot/FloatingChatbot";
import { loadOldChat, receiveMessage, updateMessageStatus } from "../../data/redux/slices/WabaChatSlice";
import { fetchWabaTemplates } from "../../data/redux/slices/WabaTemplateSlice";
import { Typography } from "antd";
import AvatarInitialStyles from "../nameInitialStyles/AvatarInitialStyles";
import NotificationDropdown from "../notifications/NotificationDropdown";

const Header = () => {
  const route = all_routes;
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userProfile = useSelector((state) => state.profile);
  const mobileSidebar = useSelector((state) => state.common.mobileSidebar);
  const miniSidebar = useSelector((state) => state.common.miniSidebar);
  const yeastar = useSelector((state) => state.yeastar);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [clientPhoneNumber, setClientPhoneNumber] = useState("");
  const [wsConnected, setWsConnected] = useState(false);
  const credits        = useSelector((state) => state.credits.balance);
  const loadingCredits = useSelector((state) => state.credits.loading);
  const phoneNumber = useAppSelector((state) => state.appCommon.phone);
  const { Title, Text } = Typography;
  const { isOpen } = useSelector((state) => state.floatingDialer);
  // Phone search states
  const [searchPhone, setSearchPhone] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const debouncedSearchPhone = useDebounce(searchPhone, 500);
  const searchRef = useRef(null);





  const userInfo = {
    name:
      userProfile.firstname && userProfile.lastname
        ? `${userProfile.firstname} ${userProfile.lastname}`
        : userProfile.email || "User",
    firstname: userProfile.firstname || "",
    lastname: userProfile.lastname || "",
    email: userProfile.email || "",
    avatar: userProfile.profileImageURL || null,
    yeastarExtensionId: userProfile.yeastarExtensionId,
    extensionNumber: userProfile.extensionNumber,
    role: userProfile.role || "User",
  };


  useEffect(() => {
    setClientPhoneNumber(phoneNumber);
    phoneNumber && showDropdown();
  }, [phoneNumber]);


  useEffect(() => {

    if (userProfile?.accounts?.whatsapp?.isConnected) {

      dispatch(fetchWabaTemplates())
    }
  }, [])


  useEffect(() => {
    if (userProfile.id) dispatch(fetchCredits());
  }, [userProfile.id]);

  // Handle phone search with debouncing
  useEffect(() => {
    if (debouncedSearchPhone.trim()) {
      handlePhoneSearch(debouncedSearchPhone);
    } else {
      setSearchResults([]);
      setShowSearchResults(false);
    }
  }, [debouncedSearchPhone]);

  // Close search dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSearchResults(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const handleRecharge = () => {
    navigate("/");
  };

  useEffect(() => {
    let ws;

    const connectWebSocket = () => {
      const token = localStorage.getItem("token");
      ws = new WebSocket(
        `wss://o6iyrho5q6.execute-api.eu-north-1.amazonaws.com/production?token=${token}`
      );

      ws.onopen = () => {
        console.log("[WS] Connected");
        setWsConnected(true);
      };

      ws.onmessage = (event) => {
        if (!event.data) return;

        try {
          const data = JSON.parse(event.data);

          if (data.type === "whatsapp_message" && data.message) {
            dispatch(receiveMessage(data.message));
          }
          if (data.type === "message_status_update" && data.message) {
            dispatch(updateMessageStatus({
              conversationId: data.message.conversationId,
              metaMessageId: data.message.metaMessageId,
              status: data.message.status
            }));

          }
        } catch (err) {
        }
      };


      ws.onclose = (event) => {
        console.warn(`[WS] Disconnected code=${event.code} — reconnecting in 3s`);
        setWsConnected(false);
        setTimeout(connectWebSocket, 3000);
      };

      ws.onerror = (err) => {
        console.error("[WS] Error:", err);
        setWsConnected(false);
        ws.close();
      };
    };

    connectWebSocket(); // start the first connection

    return () => {
      if (ws) ws.close(); // cleanup when component unmounts
    };
  }, [dispatch]);

  const handlePhoneSearch = async (phone) => {
    setIsSearching(true);
    try {
      const response = await api.get(
        `/getAllContactsOrLeads/searchByPhone?phone=${encodeURIComponent(
          phone
        )}`
      );
      if (response.data.status === "success") {
        setSearchResults(response.data.results || []);
        setShowSearchResults(true);
      }
    } catch (error) {
      console.error("Phone search error:", error);
      setSearchResults([]);
    } finally {
      setIsSearching(false);
    }
  };

  const handleClearSearch = () => {
    if (!searchPhone) return;
    setSearchPhone("");
    setSearchResults([]);
    setShowSearchResults(false);
  };

  // const getOwnerDisplay = (result) => {
  //   const isCurrentUser = result.ownerId === userProfile.id;
  //   if (isCurrentUser) {
  //     return "You";
  //   }
  //   const roleLabel = result.ownerRole === "user" ? " (Agent)" : "";
  //   return `${result.ownerName}${roleLabel} (${result.ownerEmail})`;
  // };

  // const toggleDropdown = () => {
  //   setOpenDropdown(!openDropdown);
  //   console.log("toggle dropdown called");

  //   dispatch(setPhone(""));
  // };
  const showDropdown = () => {
    setOpenDropdown(true);
  };

  const toggleMobileSidebar = () => {
    dispatch(setMobileSidebar(!mobileSidebar));
  };
  // const toggleMiniSidebar = () => {
  //   dispatch(setMiniSidebar(!miniSidebar));
  // };
  // const toggleExpandMenu = () => {
  //   dispatch(setExpandMenu(true));
  // };
  // const toggleExpandMenu2 = () => {
  //   dispatch(setExpandMenu(false));
  // };
  useEffect(() => {

    if (userProfile?.extensionStatus) {
      const fetchCalls = async () => {
        try {
          const response = await api.post("call/fetch-and-store");
        } catch (error) {
        }
      };
      fetchCalls();
    }
  }, []);


  const handleLogout = async () => {
    try {
      // Clear all localStorage data
      localStorage.removeItem("userId");
      localStorage.removeItem("token");

      // Reset Redux state
      // dispatch(resetProfile());

      // // Navigate to login
      // dispatch(clearContactsCache());
      // dispatch(clearLeadsCache());

      window.location.href = "/";

    } catch (error) {
      console.error("❌ Logout error:", error);

      // Still proceed with logout even if there's an error
      localStorage.removeItem("userId");
      localStorage.removeItem("token");
      dispatch(resetProfile());
      window.location.href = "/";
    }
  };

  // const [layoutBs, setLayoutBs] = useState(localStorage.getItem("dataTheme"));
  // const isLockScreen = location.pathname === "/lock-screen";

  // if (isLockScreen) {
  //   return null;
  // }
  // const LayoutDark = () => {
  //   localStorage.setItem("dataTheme", "dark");
  //   document.documentElement.setAttribute("data-theme", "dark");
  //   setLayoutBs("dark");
  // };
  // const LayoutLight = () => {
  //   localStorage.setItem("dataTheme", "light");
  //   document.documentElement.setAttribute("data-theme", "light");
  //   setLayoutBs("light");
  // };

  return (
    <>
      {/* Header */}
      <div className="header" style={{ zIndex: 1000 }}>
        {/* Logo */}
        <div className="header-left active">
          {/* <div className="header-left active" onMouseEnter={toggleExpandMenu} onMouseLeave={toggleExpandMenu2}> */}
          <Link to={route.dashboard} className="logo logo-normal">
            {/* {layoutBs === "dark" ? (
              <>
                <ImageWithBasePath
                  src="assets/img/white-logo.svg"
                  className="white-logo"
                  alt="Logo"
                />
              </>
            ) : (
              <ImageWithBasePath src="assets/img/logo.svg" alt="Logo" />
            )} */}
            <ImageWithBasePath src="assets/img/voycell-logo.webp" alt="Logo" />
            {/* <FloatingChatbot/> */}
            <ImageWithBasePath
              src="assets/img/white-logo.svg"
              className="white-logo"
              alt="Logo"
            />
          </Link>
          <Link to={route.dashboard} className="logo-small">
            <ImageWithBasePath src="assets/img/favicon.ico" alt="Logo" />
          </Link>
          {/* <Link id="toggle_btn" to="#" onClick={toggleMiniSidebar}>
            <i className="ti ti-arrow-bar-to-left" />
          </Link> */}
        </div>
        {/* /Logo */}
        <Link
          id="mobile_btn"
          className="mobile_btn"
          to="#sidebar"
          onClick={toggleMobileSidebar}
        >
          <span className="bar-icon">
            <span />
            <span />
            <span />
          </span>
        </Link>
        <div className="header-user">
          <ul className="nav user-menu justify-content-end">
     


            <li className="nav-item nav-search-inputs me-auto">








              {/* <Text className="welcome-text" ellipsis>
                  Welcome back,{" "}
                  {userInfo.firstname || userInfo.name}!
                </Text> */}

              <Text className="welcome-text">
                Welcome back,{" "}
                {(userInfo.firstname || userInfo.name).length > 30
                  ? `${(userInfo.firstname || userInfo.name).slice(0, 30)}…`
                  : userInfo.firstname || userInfo.name}!
              </Text>


















            </li>
      
            <li className="nav-item nav-search-inputs ms-auto">
              <div className="top-nav-search" ref={searchRef}>
                <Link to="#" className="responsive-search">
                  <i className="fa fa-search" />
                </Link>
                <div className="dropdown" style={{ position: "relative" }}>
                  <div className="searchinputs" id="dropdownMenuClickable">
                    <input
                      type="text"
                      placeholder="Search by phone number"
                      value={searchPhone}
                      onChange={(e) => setSearchPhone(e.target.value)}
                      onFocus={() =>
                        searchResults.length > 0 && setShowSearchResults(true)
                      }
                    />
                    <div
                      className="search-addon"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      {
                        <button
                          type="button"
                          onClick={handleClearSearch}
                          style={{
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            padding: "0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {isSearching ? (
                            <i className="fa fa-spinner fa-spin" />
                          ) : searchPhone ? (
                            <i className="ti ti-x" />
                          ) : (
                            <i className="ti ti-search" />
                          )}
                        </button>
                      }
                      {/* <button
                        type="button"
                        style={{
                          background: "transparent",
                          border: "none",
                          padding: "0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {isSearching ? (
                          <i className="fa fa-spinner fa-spin" />
                        ) : (
                          <i className="ti ti-search" />
                        )}
                      </button> */}
                    </div>
                  </div>

                  {/* Search Results Dropdown */}
                  {showSearchResults && (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        backgroundColor: "white",
                        border: "1px solid #e9ecef",
                        borderRadius: "4px",
                        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                        maxHeight: "400px",
                        overflowY: "auto",
                        zIndex: 1000,
                        marginTop: "4px",
                      }}
                    >
                      {searchResults.length === 0 ? (
                        <div
                          style={{
                            padding: "16px",
                            textAlign: "center",
                            color: "#6c757d",
                          }}
                        >
                          No results found
                        </div>
                      ) : (
                        searchResults.map((result, index) => (
                          <div
                            key={index}
                            style={{
                              padding: "12px 16px",
                              borderBottom:
                                index < searchResults.length - 1
                                  ? "1px solid #f0f0f0"
                                  : "none",
                              cursor: "pointer",
                              transition: "background-color 0.2s",
                            }}
                            onMouseEnter={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              "#f8f9fa")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.backgroundColor = "white")
                            }
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: "4px",
                              }}
                            >
                              <span
                                style={{
                                  display: "inline-block",
                                  padding: "2px 8px",
                                  borderRadius: "4px",
                                  fontSize: "11px",
                                  fontWeight: "600",
                                  marginRight: "8px",
                                  backgroundColor:
                                    result.type === "contact"
                                      ? "#d1ecf1"
                                      : "#fff3cd",
                                  color:
                                    result.type === "contact"
                                      ? "#0c5460"
                                      : "#856404",
                                }}
                              >
                                {result.type === "contact" ? "Contact" : "Lead"}
                              </span>
                              <strong style={{ fontSize: "14px" }}>
                                {result.firstname} {result.lastname}
                              </strong>
                            </div>
                            <div
                              style={{
                                fontSize: "13px",
                                color: "#495057",
                                marginBottom: "4px",
                              }}
                            >
                              {result.phoneNumbers?.map((phone, idx) => (
                                <div key={idx}>
                                  +{phone.countryCode} {phone.number}
                                </div>
                              ))}
                            </div>
                            <div
                              style={{
                                fontSize: "12px",
                                color: "#6c757d",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                flexWrap: "wrap",
                              }}
                            >
                              <span>Owner:</span>
                              {result.ownerId === userProfile.id ? (
                                <span style={{ fontWeight: "500" }}>You</span>
                              ) : (
                                <>
                                  <span style={{ fontWeight: "500" }}>
                                    {result.ownerName}
                                  </span>
                                  {result.ownerRole === "user" && (
                                    <span
                                      style={{
                                        display: "inline-block",
                                        padding: "2px 6px",
                                        borderRadius: "3px",
                                        fontSize: "10px",
                                        fontWeight: "600",
                                        backgroundColor: "#e7f3ff",
                                        color: "#0066cc",
                                      }}
                                    >
                                      Agent
                                    </span>
                                  )}
                                  <span style={{ color: "#999" }}>
                                    ({result.ownerEmail})
                                  </span>
                                </>
                              )}
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  )}
                </div>
              </div>
            </li>
         
            <li className="nav-item nav-list">
              <ul className="nav">
                {/* ── Credit balance chip ── */}
                <li className="nav-item me-1">
                  <div
                    className="d-flex align-items-center bg-light rounded me-2"
                    style={{
                      border: "1px solid #e9ecef",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                      padding: "4px 4px 4px 12px",
                      gap: 8,
                    }}
                  >
                    <span style={{ fontSize: 11, color: "#9ca3af", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em" }}>
                      {userProfile.role === "user" ? "Company Balance" : "Balance"}
                    </span>
                    <span style={{ fontSize: 14, fontWeight: 800, color: "#3C2371" }}>
                      {loadingCredits ? "…" : `$${Number(credits).toFixed(2)}`}
                    </span>
                    <button
                      onClick={() => dispatch(fetchCredits())}
                      title="Refresh Balance"
                      disabled={loadingCredits}
                      style={{
                        width: 28, height: 28, borderRadius: "50%",
                        background: "transparent", border: "1px solid #d1d5db",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        cursor: "pointer", flexShrink: 0,
                      }}
                    >
                      <i className="ti ti-refresh" style={{ fontSize: 13, color: "#6b7280", animation: loadingCredits ? "spin 1s linear infinite" : "none" }} />
                    </button>
                    {userProfile.role !== "user" && (
                      <button
                        onClick={() => navigate(route.credits)}
                        title="Add Credits"
                        style={{
                          width: 28, height: 28, borderRadius: "50%",
                          background: "#3C2371", border: "none",
                          display: "flex", alignItems: "center", justifyContent: "center",
                          cursor: "pointer", flexShrink: 0,
                          boxShadow: "0 2px 6px rgba(60,35,113,0.3)",
                        }}
                      >
                        <i className="ti ti-plus" style={{ fontSize: 14, color: "#ffffff", fontWeight: 700 }} />
                      </button>
                    )}
                  </div>
                </li>

                <li className="nav-item">
                  <div
                    className="d-flex align-items-center bg-light rounded me-2"
                    style={{
                      border: "1px solid #e9ecef",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                      padding: "4px 12px",
                      paddingRight: "4px",
                      cursor: "pointer",
                      justifyContent: "space-between",
                    }}
                  >
                    <Link
                      to="#"
                      className="d-flex align-items-center"
                      aria-expanded="false"
                      onClick={() => {
                        // toggleDropdown();
                        if (isOpen) {
                          dispatch(closeDialer());
                        } else {
                          dispatch(openDialer());
                        }
                      }}
                    >
                      {/* <i className="typcn typcn-phone me-2" /> */}
                      <span className="me-2 text-primary">Dialer</span>
                      <button className="ms-2 d-flex justify-content-center align-items-center rounded bg-primary">
                        <i
                          className="ti ti-phone text-white my-1"
                          style={{ fontSize: "16px" }}
                        ></i>
                      </button>
                    </Link>
                    {isOpen && (
                      <i
                        className="ti ti-chevron-up text-muted"
                        style={{ fontSize: "14px" }}
                      ></i>
                    )}

                    {/* /// Purpose of additional  userProfile?.isLinkusDialerActive , is to prevent double initialization of linkus client in header aswell as on Linkus Client page */}
                  </div>
                </li>

                {/* <li className="dark-mode-list align-items-center">
                  <Link
                    to="#"
                    className={`dark-mode-toggle ${layoutBs ? "" : "active"}`}
                    id="dark-mode-toggle"
                  >
                    <i
                      className={`ti ti-sun light-mode ${
                        layoutBs === "dark" ? "" : "active"
                      }`}
                      onClick={LayoutLight}
                    >
                      {" "}
                    </i>
                    <i
                      className={`ti ti-moon dark-mode ${
                        layoutBs === "dark" ? "active" : ""
                      }`}
                      onClick={LayoutDark}
                    ></i>
                  </Link>
                </li> */}
                {/* <li className="nav-item dropdown">
                  <Link
                    to="#"
                    className="btn btn-header-list"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-layout-grid-add" />
                  </Link>
                  <div className="dropdown-menu dropdown-menu-end menus-info">
                    <div className="row">
                      <div className="col-md-6">
                        <ul className="menu-list">
                          <li>
                            <Link to={route.leads}>
                              <div className="menu-details">
                                <span className="menu-list-icon bg-violet">
                                  <i className="ti ti-user-up" />
                                </span>
                                <div className="menu-details-content">
                                  <p>Contacts</p>
                                  <span>Add New Contact</span>
                                </div>
                              </div>
                            </Link>
                          </li>
                          <li>
                            <Link to={route.leads}>
                              <div className="menu-details">
                                <span className="menu-list-icon bg-green">
                                  <i className="ti ti-timeline-event-exclamation" />
                                </span>
                                <div className="menu-details-content">
                                  <p>Pipline</p>
                                  <span>Add New Pipline</span>
                                </div>
                              </div>
                            </Link>
                          </li>
                          <li>
                            <Link to={route.leads}>
                              <div className="menu-details">
                                <span className="menu-list-icon bg-pink">
                                  <i className="ti ti-bounce-right" />
                                </span>
                                <div className="menu-details-content">
                                  <p>Activities</p>
                                  <span>Add New Activity</span>
                                </div>
                              </div>
                            </Link>
                          </li>
                          <li>
                            <Link to={route.leads}>
                              <div className="menu-details">
                                <span className="menu-list-icon bg-info">
                                  <i className="ti ti-analyze" />
                                </span>
                                <div className="menu-details-content">
                                  <p>Analytics</p>
                                  <span>Shows All Information</span>
                                </div>
                              </div>
                            </Link>
                          </li>
                          <li>
                            <Link to={route.leads}>
                              <div className="menu-details">
                                <span className="menu-list-icon bg-danger">
                                  <i className="ti ti-atom-2" />
                                </span>
                                <div className="menu-details-content">
                                  <p>Projects</p>
                                  <span>Add New Project</span>
                                </div>
                              </div>
                            </Link>
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-6">
                        <ul className="menu-list">
                          <li>
                            <Link to={route.leads}>
                              <div className="menu-details">
                                <span className="menu-list-icon bg-info">
                                  <i className="ti ti-medal" />
                                </span>
                                <div className="menu-details-content">
                                  <p>Deals</p>
                                  <span>Add New Deals</span>
                                </div>
                              </div>
                            </Link>
                          </li>
                          <li>
                            <Link to={route.leads}>
                              <div className="menu-details">
                                <span className="menu-list-icon bg-secondary">
                                  <i className="ti ti-chart-arcs" />
                                </span>
                                <div className="menu-details-content">
                                  <p>Leads</p>
                                  <span>Add New Leads</span>
                                </div>
                              </div>
                            </Link>
                          </li>
                          <li>
                            <Link to={route.leads}>
                              <div className="menu-details">
                                <span className="menu-list-icon bg-tertiary">
                                  <i className="ti ti-building-community" />
                                </span>
                                <div className="menu-details-content">
                                  <p>Company</p>
                                  <span>Add New Company</span>
                                </div>
                              </div>
                            </Link>
                          </li>
                          <li>
                            <Link to={route.leads}>
                              <div className="menu-details">
                                <span className="menu-list-icon bg-success">
                                  <i className="ti ti-list-check" />
                                </span>
                                <div className="menu-details-content">
                                  <p>Tasks</p>
                                  <span>Add New Task</span>
                                </div>
                              </div>
                            </Link>
                          </li>
                          <li>
                            <Link to={route.leads}>
                              <div className="menu-details">
                                <span className="menu-list-icon bg-purple">
                                  <i className="ti ti-brand-campaignmonitor" />
                                </span>
                                <div className="menu-details-content">
                                  <p>Campaign</p>
                                  <span>Add New Campaign</span>
                                </div>
                              </div>
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </li> */}
              </ul>
            </li>

            <li className="nav-item" style={{ display: "flex", alignItems: "center" }}>
              <NotificationDropdown />
            </li>

            <li className="nav-item dropdown has-arrow main-drop">
              <Link
                to={route.profile}
                className="nav-link userset me-2"
              // data-bs-toggle="dropdown"
              >
                <span className="user-info">
                  <span className="user-letter">
                    {userProfile.profileImageURL?.startsWith("http") ? (
                      <img
                        src={userProfile.profileImageURL}
                        alt="Profile"
                        style={{ objectFit: "contain", height: "100%" }}
                      />
                    ) : (
                       <AvatarInitialStyles
                                name={`${userProfile.firstname || ""} ${userProfile.lastname || ""}`}
                                divStyles={{ width:40, height:40, borderRadius:8 }}
                              />
                    )}
                  </span>
                  <span className="badge badge-success rounded-pill" />
                </span>
              </Link>
            </li>
            {/* <li>
                <Link
                  // className="dropdown-item"
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#logoutModal"
                >
                  <ImageWithBasePath
                    src="assets/img/icons/logout.png"
                    alt="Logout"
                    width={15}
                    className="me-3"
                  />
                </Link>
              </li> */}
            {/* /Profile Dropdown */}
          </ul>
        </div>
        {/* Mobile Menu */}
        <div className="dropdown mobile-user-menu">
          <Link
            to="#"
            className="nav-link dropdown-toggle border-0"
            style={{boxShadow:"none"}}
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className={` dropdown-menu `}>
            {/* <Link className="dropdown-item" to={route.dashboard}>
              <i className="ti ti-layout-2" /> Dashboard
            </Link> */}
            <Link className="dropdown-item" to={route.profile}>
              <i className="ti ti-user-pin" /> My Profile
            </Link>
            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#logoutModal"
            >
              <i className="ti ti-lock" /> Logout
            </Link>
          </div>
        </div>
        {/* /Mobile Menu */}
      </div>
      <FloatingDialer />

      {/* Logout Modal */}
      <div
        className="modal fade"
        id="logoutModal"
        tabIndex="-1"
        aria-labelledby="logout"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-theme-light rounded-circle mb-3">
                  <i className="fa-solid fa-right-from-bracket fs-36 text-theme" />
                </div>
                <h4 className="mb-2 text-capitalize">Logout?</h4>
                <p className="mb-0">
                  Are you sure you want to logout from your account?
                </p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link
                    to={"#"}
                    data-bs-dismiss="modal"
                    className="btn btn-theme text-white"
                    onClick={() => {
                      handleLogout();
                    }}
                  >
                    Yes, Logout
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
